import React from 'react';
import { Button, Card, CardBody, Table, Badge } from 'reactstrap';
import BillToPartyView from '@src/components/EvidenceOfInsurance/EvidenceOfInsuranceEdit/EvidenceOfInsuranceForm/BillToPartyView/BillToPartyView';
import UnitView from '@src/components/EvidenceOfInsurance/EvidenceOfInsuranceEdit/EvidenceOfInsuranceForm/UnitView/UnitView';

export default props => {
  return (
    <Card className={'h-100'}>
      <CardBody>
        <div className={'font-md color-blue'}>
          <span className={'text-capitalize'}>Billing & Delivery Options</span>
          &nbsp;&nbsp;
          <Button color={'link'} onClick={props.toggleModal}>
            Edit
          </Button>
        </div>
        <div className={'pt-2 content'}>
          <Table borderless size={'sm'}>
            <tbody>
              <tr>
                <th>Chargeable</th>
                <td>{props.entity.chargeable === 0 ? 'NO' : 'YES'}</td>
              </tr>
              <tr>
                <th style={{ width: '80px' }}>Bill To</th>
                <td>
                  {props.entity.lender !== null && (
                    <BillToPartyView
                      {...props.entity.lender}
                      link={true}
                      billToType={'lender'}
                    />
                  )}
                  {props.entity.escrow_company !== null && (
                    <BillToPartyView
                      {...props.entity.escrow_company}
                      link={true}
                      billToType={'escrow-company'}
                    />
                  )}
                  {props.entity.bill_to_type === 'homeowner' && (
                    <UnitView {...props.entity} />
                  )}
                </td>
              </tr>
              <tr>
                <th>Email</th>
                <td>{props.entity.invoice_email}</td>
              </tr>
              <tr>
                <th>CC</th>
                <td>{props.entity.email_cc}</td>
              </tr>
              <tr>
                <th>BCC</th>
                <td>{props.entity.email_bcc}</td>
              </tr>
              {props.entity.fax_number !== null &&
                props.entity.fax_number.length > 0 && (
                  <tr>
                    <th>Fax</th>
                    <td>{props.entity.fax_number}</td>
                  </tr>
                )}
              <tr>
                <th>EOI Fee</th>
                <td>
                  {props.entity.evidence_of_insurance_pricing !== null && (
                    <React.Fragment>
                      ${props.entity.evidence_of_insurance_pricing.rate} (
                      {props.entity.evidence_of_insurance_pricing.item_name})
                    </React.Fragment>
                  )}
                </td>
              </tr>
              <tr>
                <th>Pre-Pay</th>
                <td>
                  {props.entity.pre_pay === 1 ? (
                    <Badge color={'danger'}>REQUIRED</Badge>
                  ) : (
                    'Not Required'
                  )}
                </td>
              </tr>
              <tr>
                <th>Invoice</th>
                <td>
                  {props.entity.qb_invoice_id !== null ? (
                    props.entity.qb_invoice_removed ? (
                      <React.Fragment>
                        <span style={{ color: '#721c24' }}>
                          Invoice link is no longer valid.
                        </span>
                        <br />
                        <Button
                          color={'link'}
                          className={'p-0 m-0'}
                          onClick={props.createInvoice}
                          disabled={props.entity.bill_to_type.length === 0}
                        >
                          Click Here to Create Invoice
                        </Button>
                      </React.Fragment>
                    ) : (
                      <React.Fragment>
                        <a
                          href={props.entity.qb_invoice_link}
                          className={'p-0 m-0'}
                          target={'_blank'}
                        >
                          View Invoice #{props.entity.qb_invoice_number}&nbsp;
                          {props.entity.qb_invoice_paid ? (
                            <Badge color={'success'}>PAID</Badge>
                          ) : (
                            <Badge color={'danger'}>UNPAID</Badge>
                          )}
                        </a>
                        <br />
                        <Button
                          color={'link'}
                          className={'p-0 m-0'}
                          style={{ fontSize: '14px', textDecoration: 'none' }}
                          onClick={props.sendQBInvoice}
                        >
                          Email Invoice
                        </Button>
                        &nbsp;
                        {props.entity.qb_invoice_sent ? (
                          <Badge color={'success'}>SENT</Badge>
                        ) : (
                          <Badge color={'danger'}>UNSENT</Badge>
                        )}
                      </React.Fragment>
                    )
                  ) : (
                    <Button
                      color={'link'}
                      className={'p-0 m-0'}
                      onClick={props.createInvoice}
                      disabled={
                        props.entity.bill_to_type.length === 0 ||
                        props.entity.invoice_email.length === 0
                      }
                    >
                      Click Here to Create Invoice
                    </Button>
                  )}
                </td>
              </tr>
            </tbody>
          </Table>
        </div>
      </CardBody>
    </Card>
  );
};
